import { HttpErrorResponse } from '@angular/common/http';
import { createFeature, createReducer, on } from '@ngrx/store';
import { ErrorHandlerActions } from './error-handler.actions';

export const errorHandlerFeatureKey = 'errorHandler';

export interface State {
  error: HttpErrorResponse | null;
}

export const initialState: State = {
  error: null,
};

export const errorHandlerReducer = createReducer(
  initialState,
  on(ErrorHandlerActions.setError, (state, { error }) => ({
    ...state,
    error,
  })),
  on(ErrorHandlerActions.clearError, (state, { error }) => ({
    ...state,
    error: state.error === error ? null : state.error, // Clear only if it matches the current error
  })),
);

export const errorHandlerFeature = createFeature({
  name: errorHandlerFeatureKey,
  reducer: errorHandlerReducer,
});
